// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PullRequestOutlinedSvg from "@fishx/icons-svg/es/asn/PullRequestOutlined";
import FishxIcon from '../components/FishxIcon';

var PullRequestOutlined = function PullRequestOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PullRequestOutlinedSvg
  }));
};

PullRequestOutlined.displayName = 'PullRequestOutlined';
export default React.forwardRef(PullRequestOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PullRequestOutlined.js
// module id = 3936
// module chunks = 0